import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { canUseCollegeSection, sectionForPath } from '@/lib/college-access';
import { useCollegeRole } from '@/hooks/useCollegeRole';
import { studentEquivalent } from '@/lib/workspace';
import { useUIStore } from '@/store/ui-store';
import { RoleRestrictedNotice } from '@/components/layouts/RoleRestrictedNotice';

/**
 * Layout route around every /college page: a member whose role can't use the
 * page (a faculty member opening /college/billing from a bookmark, say) gets a
 * plain explanation instead of a page full of permission errors. Students
 * don't use the staff workspace at all: they're sent to the matching page of
 * their college home. The sidebar already hides these links; the server still
 * enforces every call.
 */
export const CollegeSectionGate: React.FC = () => {
  const { pathname } = useLocation();
  const { role, permissions } = useCollegeRole();
  const clearWorkspaceContext = useUIStore((s) => s.clearWorkspaceContext);
  const section = sectionForPath(pathname);
  const isStudent = role === 'STUDENT';

  useEffect(() => {
    if (isStudent) clearWorkspaceContext();
  }, [isStudent, clearWorkspaceContext]);

  if (isStudent) return <Navigate to={studentEquivalent(pathname)} replace />;
  if (section && role && !canUseCollegeSection(role, section, permissions)) {
    return <RoleRestrictedNotice homeTo="/college/dashboard" adminLabel="a college admin" />;
  }
  return <Outlet />;
};
